import { useRef } from 'react'
import PropTypes from 'prop-types'
import { motion } from 'framer-motion'
import styles from './Header.module.scss'

Header.propTypes = {
  children: PropTypes.element.isRequired,
  variant: PropTypes.oneOf(['default', 'popup'])
}

Header.defaultProps = {
  variant: 'default'
}

export default function Header ({ children, variant }) {
  const headerRef = useRef(null)

  const motionVariants = {
    default: {
      hidden: { y: '-100%' },
      visible: {
        y: 0,
        transition: {
          duration: 0.4,
          ease: 'easeInOut'
        }
      }
    },
    popup: {
      hidden: { y: '-100%' },
      visible: {
        y: 0,
        transition: {
          duration: 0.25,
          ease: 'easeOut'
        }
      }
    }
  }

  const DefaultVariant = <motion.header
    className={ styles.container }
    variants={ motionVariants.default }
    initial="hidden"
    animate="visible">
    { children }
  </motion.header>

  const PopupVariant = <motion.header
    ref={ headerRef }
    className={ styles.container }
    variants={ motionVariants.popup }
    initial="hidden"
    whileInView="visible">
    { children }
  </motion.header>

  const componentVariants = {
    default: DefaultVariant,
    popup: PopupVariant
  }

  const Component = () => componentVariants[variant]

  return <Component>{ children }</Component>
}
